
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc9b95beb66b8fdddec5f24bf0fb379cfen from './en.yaml'
            i18n.addResourceBundle('en', 'c9b95beb66b8fdddec5f24bf0fb379cf', flattenObject(nsc9b95beb66b8fdddec5f24bf0fb379cfen), true, true);
        
        export default 'c9b95beb66b8fdddec5f24bf0fb379cf';
    